import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Handshake icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Handshake } from '@sravni/design-system-icons'
 *
 * <Handshake />
 * ```
 */
var Handshake = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Handshake", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", d: "M1.774 13.778H3.29a1.333 1.333 0 0 0 1.333-1.333V7.11A1.333 1.333 0 0 0 3.29 5.778H2.02m15.871 0h-1.268a1.333 1.333 0 0 0-1.333 1.333v5.334a1.333 1.333 0 0 0 1.333 1.333h1.517" }),
    React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", d: "M15.31 12.675h-.86c-.285 0-.568.06-.828.18L9.413 14.77m-.813-8.075a1.988 1.988 0 0 0-1.675-.164l-2.303.829m10.828-.897-2.876-1.266a2.001 2.001 0 0 0-1.893.152l-2.61 1.69A1.506 1.506 0 0 0 9.527 9.67l1.556-.726" }),
    React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", d: "M16.321 3.664A9 9 0 1 1 3.593 16.392 9 9 0 0 1 16.322 3.664" }),
    React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", d: "m11.083 8.942.79.717a2 2 0 0 1 .008 2.957l-2.017 1.846c-.761.698-1.929.7-2.693.007l-1.386-1.257a1.997 1.997 0 0 0-1.185-.5" }))); });

export { Handshake };
//# sourceMappingURL=Handshake.js.map
